<template>
	<div class="ao-desktop-select-layout">
		<div class="d-flex align-start">
			<div class="flex-grow-1">

				<!-- <div class="select-activator"> -->
				<!-- <slot
					name="activator"
				/> -->

				<v-menu
					:modelValue="modelValue"
					class="w-100"
					:disabled="disabled"
					:close-on-content-click="false"
					@update:modelValue="$emit('update:modelValue', $event)"
				>

					<template #activator="{ props: menuActivatorProps }">
						<div class="select-activator">
							<slot
								name="activator"
								:activator-props="menuActivatorProps"
							/>
						</div>
					</template>

					<v-card
						class="pa-1 pt-3"
					>
						<slot
							name="default"
						/>
					</v-card>

				</v-menu>
				<!-- </div> -->

				<slot
					name="errors"
				/>

			</div>

			<slot
				name="addAction"
			/>

		</div>
	</div>
</template>

<script setup>

defineProps({

	modelValue: {
		type: Boolean,
		required: true,
	},

	disabled: {
		type: Boolean,
		default: false,
	},

	label: {
		type: String,
		default: null,
	},

})

defineEmits({
	'update:modelValue': null,
})

</script>
